module.exports = __webpack_public_path__ + "img/oj-logo.dd50392e.png";